import React from "react";

export default function Timeline(props) {
  const CurrentTag = () => {
    return (
      <span className="text-teal-400 text-xs font-medium px-2.5 py-0.5 rounded bg-teal-500/10 border border-teal-500/40 ml-3 whitespace-nowrap">
        Current
      </span>
    );
  };

  const Badge = ({ children }) => {
    return (
      <span className="text-teal-400 text-xs font-medium px-2.5 py-0.5 rounded bg-gray-800">
        {children}
      </span>
    );
  };

  return (
    <li className="mb-6 ml-6">
      <span className="flex absolute -left-3 justify-center items-center w-6 h-6 rounded-full ring-8 ring-gray-900 green-bg">
        {props.data.current && (
          <span
            className="animate-ping absolute inline-flex h-full w-full rounded-full green-bg opacity-60"
            aria-hidden="true"
          ></span>
        )}
        {props.type === "education" && (
          <i className="fa fa-graduation-cap text-xs text-black relative" aria-hidden="true"></i>
        )}
        {props.type === "work" && (
          <i className="fa fa-briefcase text-xs text-black relative" aria-hidden="true"></i>
        )}
      </span>

      <div className="rounded-lg p-3 -ml-3 transition-colors duration-200 hover:bg-white/5">
        <h3 className="flex flex-wrap items-center mb-1 text-lg font-semibold text-white">
          {props.data.name}
          {props.data.current && <CurrentTag />}
        </h3>
        <time className="block mb-2 text-sm font-normal leading-none text-gray-500">
          {props.data.timeline}
        </time>
        {(props.data.location || props.data.jobType || props.data.workMode) && (
          <div className="flex flex-wrap items-center gap-2 mb-2">
            {props.data.location && (
              <span className="text-sm font-normal text-gray-500">
                <i className="fa fa-map-marker mr-1.5 text-teal-500" aria-hidden="true"></i>
                {props.data.location}
              </span>
            )}
            {props.data.jobType && <Badge>{props.data.jobType}</Badge>}
            {props.data.workMode && <Badge>{props.data.workMode}</Badge>}
          </div>
        )}
        {props.data.desc && (
          <p className="text-base font-normal text-gray-400">{props.data.desc}</p>
        )}
      </div>
    </li>
  );
}
